import { useEffect, useState } from 'react';
import { axiosInstance } from '../helpers/axios';
import { IEventCard } from '../types/types';

interface UseFetchEventsParams {
    page: number;
    size?: number;
    format?: string;
    place?: string;
    search?: string;
    eventDateGte?: string;
    eventDateLte?: string;
    // null — «Все»: без фильтра по дате
    isActual?: boolean | null;
    // общая лента мероприятий и новостей с галочкой «Это мероприятие»:
    // upcoming — ближайшие, archive — прошедшие; даты и порядок считает бэкенд
    feed?: 'upcoming' | 'archive';
}

export const useFetchEvents = ({
    page,
    size = 10,
    format,
    place,
    search,
    eventDateGte, // например, "2025-10-19"
    eventDateLte,
    isActual = true, // если передан event_date_gte или event_date_lte, игнорируем этот параметр
    feed,
}: UseFetchEventsParams) => {
    const [eventsData, setEventsData] = useState<IEventCard[] | null>(null);
    const [totalCount, setTotalCount] = useState<number | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        // Объявляем сегодня/вчера
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);

        const todayStr = today.toISOString().split('T')[0];
        const yesterdayStr = yesterday.toISOString().split('T')[0];

        const base = feed ? `/v1/event/${feed}/` : '/v1/event/';
        let url = `${base}?page=${page}&size=${size}`;
        if (format) url += `&event_format=${format}`;
        if (place) url += `&location=${place}`;
        if (search) url += `&search_query=${search}`;

        if (!feed && (eventDateGte || eventDateLte)) {
            if (eventDateGte) url += `&event_date_gte=${eventDateGte}`;
            if (eventDateLte) url += `&event_date_lte=${eventDateLte}`;
        } else if (!feed && isActual !== null) {
            // если eventDateGte и eventDateLte пустые, смотрим isActual;
            // null означает «все» — тогда по дате не фильтруем вовсе
            if (isActual) {
                url += `&event_date_gte=${todayStr}`;
            } else {
                url += `&event_date_lte=${yesterdayStr}`;
            }
        }

        axiosInstance
            .get(url)
            .then((response) => {
                setTotalCount(response.data.page_count);
                setEventsData(response.data.objects);
            })
            .catch((error) => console.error(error))
            .finally(() => setIsLoading(false));
    }, [page, size, format, place, search, eventDateGte, eventDateLte, isActual, feed]);

    return { eventsData, isLoading, totalCount };
};
